import React from 'react';
import Logo from '../../assets/images/logo.svg';
import { Form, Row, Col, Button, Spinner } from 'react-bootstrap';
import { useState } from 'react';
import '../ForgotPassword/forgotPassword.scss';
import EmailIcon from '../../assets/images/email-check-icon.svg';
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link } from 'react-router-dom';
import { FORGOT_PASSWORD } from '../../gql/auth/mutation';
import { useMutation } from '@apollo/client';

function ForgotPassword() {

    // eslint-disable-next-line
    const [confirmationShown, setConfirmationShown] = useState(false);
    const [forgotPasswordHandler, { loading, error, data }] = useMutation(FORGOT_PASSWORD)

    // const toggleBlocks = () => {
    //     setConfirmationShown(!confirmationShown);
    // };

    const formik = useFormik({
        initialValues: {
            email: ""
        },
        validationSchema: Yup.object({
            email: Yup.string()
                .email("Email should be valid")
                .required("Email is required")
                .matches(/^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/, "Email should be valid"),
        }),
        onSubmit: (values) => {
            try {
                forgotPasswordHandler({
                    variables: {
                        email: values.email
                    }
                })
            }
            catch (e) {
                console.error(e)
            }
        }
    })

    if (data) {
        return (
            <div className='forgot-password'>
                <div className="show-block confirmation-div">
                    <img src={EmailIcon} alt="icon" />
                    <h2>Check your mail</h2>
                    <p>We have sent you a link to reset the password on your email.</p>
                    <Link to='/'>Back to Login</Link>
                </div>
            </div>
        )
    }

    let errorMessage = '';
    if (error) {
        // if(error.networkError && typeof window !== 'undefined' && !window.navigator.onLine){
        //     setErrorMessage("Check Your Network, Your Browser Is Offline")
        // }
        if (error.message) {
            // setErrorMessage(error.message)
            errorMessage = error.message
        }
        // setErrorMessage("Something Went Wrong !")
        if (!error.message) {
            errorMessage = "Something Went Wrong !"
        }
    }

    return (
        <div className='forgot-password'>
            <div className={confirmationShown ? "hide-block forgot-password-wrapper" : "show-block forgot-password-wrapper"}>
                <img className='logo' src={Logo} alt="Omnioutreach" />
                <h2>Need a new password?</h2>
                <p>Enter your email and we'll send you the link to reset the password.</p>

                <Form className="logInForm" onSubmit={formik.handleSubmit}>
                    <Row className="mb-4">
                        {
                            errorMessage && <p className='error'>{errorMessage}</p>
                        }
                        <Form.Group as={Col} md="12" controlId="email">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                name="email"
                                type="text"
                                placeholder="Enter your email"
                                value={formik.values.email}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                className={formik.errors.email && formik.touched.email && "error"}
                            />
                            {formik.errors.email && formik.touched.email && (
                                <div className="input-feedback">{formik.errors.email}</div>
                            )}
                        </Form.Group>
                    </Row>
                    {
                        (loading && !error) ?
                            <Button className='solid-button'>Get A New Password
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                            </Button>
                            :
                            <Button className='solid-button' type="submit">Get A New Password</Button>

                    }
                </Form>
                <p className='back-to-login'><Link to='/'>Back to Login</Link></p>
            </div>
            
        </div>
    )
}

export default ForgotPassword